import { gql } from '@apollo/client';

export const MUTATION_UPDATE_USER = gql`
  mutation updateUser($id: ID!, $input: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
        }
      }
    }
  }
`;

export const MUTATION_CHANGE_PASSWORD = gql`
  mutation changePassword($currentPassword: String!, $password: String!, $passwordConfirmation: String!) {
    changePassword(
      currentPassword: $currentPassword
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      __typename
    }
  }
`;
